import script from "./BrainSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainSearch.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/BrainSearch.css?vue&type=style&index=0&id=370aac36&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370aac36"]])

export default __exports__